export const elements = [
  { id: 99, user: 273, name: "HTML5", label: "HTML5" },
  { id: 92, user: 264, name: "CSS3", label: "CSS3" },
  { id: 83, user: 252, name: "JavaScript", label: "JavaScript" },
  { id: 78, user: 245, name: "TypeScript", label: "TypeScript" },
  { id: 87, user: 257, name: "React.js", label: "React.js" },
  { id: 99, user: 273, name: "Redux", label: "Redux" },
  { id: 86, user: 256, name: "React Query", label: "React Query" },
  { id: 88, user: 259, name: "Vue.js", label: "Vue.js" },
  { id: 80, user: 248, name: "Vuex", label: "Vuex" },
  { id: 80, user: 248, name: "Angular", label: "Angular" },
  { id: 89, user: 260, name: "Next.js", label: "Next.js" },
  { id: 97, user: 271, name: "Tailwind CSS", label: "Tailwind CSS" },
  { id: 100, user: 274, name: "Bootstrap", label: "Bootstrap" },
  { id: 89, user: 260, name: "Material UI", label: "Material UI" },
  { id: 75, user: 241, name: "SASS", label: "SASS" },
  { id: 88, user: 259, name: "SCSS", label: "SCSS" },
  { id: 75, user: 241, name: "LESS", label: "LESS" },
  { id: 89, user: 260, name: "Styled Components", label: "Styled Components" },
  {
    id: 93,
    user: 265,
    name: "Responsive Web Design",
    label: "Responsive Web Design",
  },
  { id: 98, user: 272, name: "RESTful APIs", label: "RESTful APIs" },
  { id: 75, user: 241, name: "GraphQL", label: "GraphQL" },
  { id: 87, user: 257, name: "Figma", label: "Figma" },
  { id: 95, user: 268, name: "Node.js", label: "Node.js" },
  { id: 81, user: 249, name: "Express.js", label: "Express.js" },
  { id: 88, user: 259, name: "Nest.js", label: "Nest.js" },
  { id: 90, user: 261, name: "PHP", label: "PHP" },
  { id: 91, user: 263, name: "Laravel", label: "Laravel" },
  { id: 92, user: 264, name: "Python", label: "Python" },
  { id: 84, user: 253, name: "Django", label: "Django" },
  { id: 83, user: 252, name: "Flask", label: "Flask" },
  { id: 75, user: 241, name: "Java", label: "Java" },
  { id: 98, user: 272, name: "Spring Boot", label: "Spring Boot" },
  { id: 78, user: 245, name: "C#", label: "C#" },
  { id: 87, user: 257, name: "ASP.NET Core", label: "ASP.NET Core" },
  { id: 79, user: 247, name: "MySQL", label: "MySQL" },
  { id: 99, user: 273, name: "PostgreSQL", label: "PostgreSQL" },
  { id: 85, user: 255, name: "MongoDB", label: "MongoDB" },
  { id: 76, user: 243, name: "SQL Server", label: "SQL Server" },
  { id: 90, user: 261, name: "Oracle DB", label: "Oracle DB" },
  { id: 82, user: 251, name: "Redis", label: "Redis" },
  { id: 79, user: 247, name: "Hadoop", label: "Hadoop" },
  { id: 90, user: 261, name: "Spark", label: "Spark" },
  { id: 75, user: 241, name: "Jest", label: "Jest" },
  { id: 86, user: 256, name: "Mocha", label: "Mocha" },
  { id: 92, user: 264, name: "Cypress", label: "Cypress" },
  { id: 78, user: 245, name: "Selenium", label: "Selenium" },
  { id: 78, user: 245, name: "Karma", label: "Karma" },
  { id: 96, user: 269, name: "Jasmine", label: "Jasmine" },
  { id: 82, user: 251, name: "Junit", label: "Junit" },
  { id: 84, user: 253, name: "UI Testing", label: "UI Testing" },
  { id: 97, user: 271, name: "CI/CD Pipelines", label: "CI/CD Pipelines" },
  { id: 100, user: 274, name: "Jenkins", label: "Jenkins" },
  { id: 76, user: 243, name: "GitLab CI/CD", label: "GitLab CI/CD" },
  { id: 75, user: 241, name: "Docker", label: "Docker" },
  { id: 77, user: 244, name: "Kubernetes", label: "Kubernetes" },
  { id: 76, user: 243, name: "AWS", label: "AWS" },
  { id: 92, user: 264, name: "Azure DevOps", label: "Azure DevOps" },
  { id: 85, user: 255, name: "GCP", label: "GCP" },
  { id: 90, user: 261, name: "Git", label: "Git" },
  { id: 96, user: 269, name: "Jira", label: "Jira" },
  { id: 80, user: 248, name: "Scrum", label: "Scrum" },
  { id: 97, user: 271, name: "Trello", label: "Trello" },
  { id: 82, user: 251, name: "Waterfall", label: "Waterfall" },
  { id: 94, user: 267, name: "Solidity", label: "Solidity" },
  { id: 83, user: 252, name: "Truffle", label: "Truffle" },
  { id: 78, user: 245, name: "Hardhat", label: "Hardhat" },
  { id: 82, user: 251, name: "Web3.js", label: "Web3.js" },
  { id: 88, user: 259, name: "Ethers.js", label: "Ethers.js" },
  { id: 100, user: 274, name: "IPFS", label: "IPFS" },
];
